export const paths = [{ "tag": "path", "att": { "d": "M12 2C6.4771 2 2 6.4771 2 12c0 5.5228 4.4771 10 10 10 5.5228 0 10-4.4772 10-10 0-5.5229-4.4772-10-10-10z" } }];
export const iconName = 'circle-filled';
export const circleFilled = { iconName, paths };
export default paths;
